import { createContext } from 'react';
import { HeaderProps } from './types';

export const HeaderContext = createContext<Pick<HeaderProps, 'dark'>>({ dark: false });
